'use client';
import React from 'react';
import {
  FullListing,
  FullListingObject,
} from '@th/shared/src/types/FullListing';
import textWithFallback from '@th/shared/src/helpers/textWithFallback';
import styles from './ListingKeyDetails.module.scss';

import KeyDetail from './KeyDetail';
import SvgIcon from '../icons/SvgIcon';
import { useUser } from '../../contexts/UserContext';
import isListingBlurred from '../../helpers/isListingBlurred';

type Props = {
  listing: FullListing;
  isBlurred: boolean;
};

export default function ListingKeyDetails({ listing, isBlurred }: Props) {
  return (
    <div>
      <div className={styles.section}>
        <KeyDetail
          icon={<SvgIcon name={'FaSolidSquareParking'} />}
          text={listing.parkingSpacesText()}
          subtitle={listing.parkingDetailsText()}
          isBlurred={isBlurred}
        />
      </div>
      <div className={styles.section}>
        <KeyDetail
          icon={<SvgIcon name={'FaSolidCalculator'} />}
          text={textWithFallback(listing.annualTaxText())}
          subtitle={listing.annualTaxTextHeader()}
          isBlurred={isBlurred}
        />
      </div>
      <div className={styles.section}>
        <KeyDetail
          icon={<SvgIcon name={'FaSolidThermometerThreeQuarters'} />}
          text={textWithFallback(listing.details.heating)}
          isBlurred={isBlurred}
        />
      </div>
      <div className={styles.section}>
        <KeyDetail
          icon={<SvgIcon name={'FaSolidSnowflake'} />}
          text={textWithFallback(listing.details.airConditioning)}
          isBlurred={isBlurred}
        />
      </div>

      {listing.isCondo() ? (
        <div>
          <div className={styles.section}>
            <KeyDetail
              icon={<SvgIcon name={'FaSolidCity'} />}
              text={'Condo'}
              isBlurred={isBlurred}
            />
          </div>
          <div className={styles.section}>
            <KeyDetail
              icon={<SvgIcon name={'FaSolidWrench'} />}
              text={textWithFallback(listing.condo.maintenanceHeader())}
              subtitle={textWithFallback(
                listing.condo.includedMaintenanceFeesSentence(),
              )}
              isBlurred={isBlurred}
            />
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.section}>
            <KeyDetail
              icon={<SvgIcon name={'FaSolidHome'} />}
              text={listing.propertyTypeText()}
              isBlurred={isBlurred}
            />
          </div>
          <div className={styles.section}>
            <KeyDetail
              icon={<SvgIcon name={'BxShapeSquare'} />}
              text={textWithFallback(listing.lotSizeText())}
              subtitle="Lot Size"
              isBlurred={isBlurred}
            />
          </div>
        </div>
      )}

      {listing.isCondo() && (
        <div className={styles.section}>
          <KeyDetail
            icon={<SvgIcon name={'ImCompass'} />}
            text={`Exposure: ${listing.condo.exposureDirection()}`}
            isBlurred={isBlurred}
          />
        </div>
      )}

      {listing.details.basement1 && (
        <div className={styles.section}>
          <KeyDetail
            icon={<SvgIcon name={'MdStairsBox'} />}
            text={listing.details.basement1}
            subtitle={listing.details.basement2}
            isBlurred={isBlurred}
          />
        </div>
      )}

      {listing.yearsOldText() && (
        <div className={styles.section}>
          <KeyDetail
            icon={<SvgIcon name={'BiHourglassSplit'} />}
            text={textWithFallback(listing.yearsOldText())}
            isBlurred={isBlurred}
          />
        </div>
      )}

      {listing.hasPool() && (
        <div className={styles.section}>
          <KeyDetail
            icon={<SvgIcon name={'FaSolidSwimmingPool'} />}
            text={textWithFallback(listing.poolText())}
            isBlurred={isBlurred}
          />
        </div>
      )}
    </div>
  );
}
